<template>
    <div>
        <Leftmenu />
        <Header />
        <div class="content">
            <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
            <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
            <div class="content-header">
                <Backbutton />
                Добавить новый Корпоративный стандарт
            </div>
            <div class="content-inner">
                <div class="header-for-input">Наименование корпоративного стандарта</div>
                <input type="text" class="content-input input_width_50" v-model="corpstandart.name" />
                <!--- --- -->
                <!-- --- --->
                <div class="header-for-input">Должность</div>
                <select class="content-input input_width_50" v-model="corpstandart.position_id">
                    <option value="0">Не выбрано</option>
                    <option v-for="position in user_positions_list_full" :key="position.id" :value="position.id">{{position.name}}</option>
                </select>
                <!-- --- --->
                <div class="header-for-input">Тип профессии</div>
                <select class="content-input input_width_50" v-model="corpstandart.position_type_id">
                    <option value="0">Не выбрано</option>
                    <option v-for="(position_type, value) in ref_type_proffession" :key="value" :value="value">{{position_type}}</option>
                </select>
                <!-- --- --->
                <div class="header-for-input">Описание </div>
                <textarea 
                    type="text" 
                    class="content-input input_width_50" 
                    v-model="corpstandart.description"
                    style="height: 150px !important"
                    >
                </textarea>
                <!--- --- -->
                <!-- --- --->
                <div class="header-for-input">Статус</div>
                <select class="content-input input_width_50" v-model="corpstandart.status_id">
                    <option value="0">Не выбрано</option>
                    <option v-for="status in cs_status_full" :key="status.id" :value="status.id">{{status.name}}</option>
                </select>
                <!-- --- --->
                <div class="btn_main_button" @click="new_corpstandart()">Добавить</div>
            </div>
        </div>
    </div>
</template>

<script>
import Leftmenu from '@/components/leftmenu.vue'
import Header from '@/components/header.vue'
import Backbutton from '@/components/elements/bacl-button.vue'
import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'

export default {
    name: 'NewCorpstandart',
    props: ['id'],
    components: {
        Leftmenu, Header, Backbutton, Success, Error
    },
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            corpstandart: {
                company_id: this.id,
                name: '',
                position_id: 0,
                position_type_id: 0,
                description: '',
                status_id: 0
            },
            user_positions_list: [],
            user_positions_list_full: {},
            cs_status_full: {},
            cs_status_list: [],
            ref_type_proffession: {
                1: 'Рабочая профессия',
                2: 'ИТР'
            }


        }
    },
    methods: {
        new_corpstandart() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.post(process.env.VUE_APP_API_URL + '/api/corpstandart', this.corpstandart)
            .then(response => {
                this.operation_info = response.data.data
                this.isSuccess = true
                loader.hide();
                this.$router.go(-1)
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
        user_positions() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/positions/'+this.id)
            .then(response => {
                this.user_positions_list_full = response.data.data
                let user_positions_list = response.data.data 
                let tmp_array = [] 
                user_positions_list.forEach(element => {
                    tmp_array[element.id] = element.name 
                    //console.log()
                });
                this.user_positions_list = tmp_array
                loader.hide();
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
        corpstandart_statuses() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/corpstandart_status')
            .then(response => {
                this.cs_status_full = response.data.data
                let cs_status_list = response.data.data 
                let tmp_array = [] 
                cs_status_list.forEach(element => {
                    tmp_array[element.id] = element.name 
                    //console.log()
                });
                this.cs_status_list = tmp_array
                loader.hide();
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        }
    },
    created() {
        this.user_positions()
        this.corpstandart_statuses()
    }
}
</script>

<style scoped src="../../../assets/style/main.css"></style>
<style scoped src="../../../assets/style/account.css"></style>
<style scoped src="../../../assets/style/buttons.css"></style>